const DeniedPage = () => {
  return (
    <div className="grid-container">
      <h1 className="text-center">denied.page</h1>
    </div>
  )
}

export default DeniedPage